import React, { ComponentProps } from 'react';

import { LoadingDots } from '../LoadingDots';

import { Button } from './Button';

import style from './SecondaryButton.scss';

import cn from 'classnames';

export function SecondaryButton({
  className,
  children,
  isLoading,
  isDisabled,
  ...props
}: ComponentProps<typeof Button>) {
  return (
    <Button
      {...props}
      className={cn(className, style.secondary)}
      isLoading={isLoading}
      isDisabled={isDisabled}
    >
      {isLoading ? <LoadingDots variant="dark" /> : children}
    </Button>
  );
}
